export default function getDisplayName(Component) {
  if (!Component) return 'Cannot get display name of null';
  // get React display name or fallback ie. for func component
  return Component.displayName || Component.name || 'Component';
}
